// Distance maps include every equal shortest route without enumerating an
// exponential number of paths. Relations are traversable in both directions.
export const PATH_COLORS = ["#f0ad5b", "#43d7cf", "#b49cff"];
export const SHARED_COLOR = "#f2efe8";
export function pathColor(mask) {
  return mask && (mask & (mask - 1)) ? SHARED_COLOR : PATH_COLORS[Math.log2(mask)] || "#65706d";
}
export function shortestPaths(graph, requested) {
  const ids = [...new Set(requested)].slice(0, 3);
  const adjacency = new Map(graph.nodes().map(id => [id, new Set()]));
  graph.forEachEdge((_id, _data, a, b) => { adjacency.get(a).add(b); adjacency.get(b).add(a); });
  const distances = new Map(ids.map(id => {
    const result = new Map();
    if (adjacency.has(id)) {
      result.set(id, 0); const queue = [id];
      for (let i = 0; i < queue.length; i++) for (const next of adjacency.get(queue[i])) {
        if (!result.has(next)) { result.set(next, result.get(queue[i]) + 1); queue.push(next); }
      }
    }
    return [id, result];
  }));
  const nodes = new Map(), edges = new Map(), pairs = [];
  for (let i = 0; i < ids.length; i++) for (let j = i + 1; j < ids.length; j++) {
    const a = ids[i], b = ids[j], da = distances.get(a), db = distances.get(b);
    const distance = da.get(b) ?? null, bit = 1 << pairs.length;
    pairs.push({ a, b, distance, color: PATH_COLORS[pairs.length], bit });
    if (distance === null) continue;
    graph.forEachNode(id => {
      if (da.get(id) + db.get(id) === distance) nodes.set(id, (nodes.get(id) || 0) | bit);
    });
    graph.forEachEdge((id, _data, u, v) => {
      if (da.get(u) + 1 + db.get(v) === distance || da.get(v) + 1 + db.get(u) === distance)
        edges.set(id, (edges.get(id) || 0) | bit);
    });
  }
  return { ids, nodes, edges, pairs };
}
